import React, { useContext } from "react";
import { Button, MenuItem, Spinner } from "@chakra-ui/react";
import { faStar, faStarHalfStroke } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ContentContext from "../../../common/context/ContentContext";
import { useDispatch, useSelector } from "react-redux";
import { contentActions, contentState } from "../../../store/slices/content";
import { Content } from "../../../common/types";
import { SizeAwareComponent } from "../../../store/types";

interface ActionProps extends SizeAwareComponent {
    content: Content | null;
    isSaving: boolean;
    onToggleFavorite: (isFavorite: boolean) => void;
}

interface OwnProps extends SizeAwareComponent { 
    mode?: "button" | "menu-item"; 
}

const FavoriteAction = ({ mode, isMinimumSize }: OwnProps) => {
    const content = useContext(ContentContext);
    const dispatch = useDispatch();
    const { isSaving } = useSelector(contentState);

    const onToggleFavorite = (isFavorite: boolean) => {
        if (content) {
            dispatch(
                contentActions.updateContent({
                    id: content._id,
                    content: { isFavorite },
                })
            );
        }
    };
    return (
        <>
            {mode === "menu-item" ?
                <FavoriteItem content={content} isSaving={isSaving} onToggleFavorite={onToggleFavorite} /> :
                <FavoriteButton content={content} isSaving={isSaving} onToggleFavorite={onToggleFavorite} isMinimumSize={isMinimumSize}/>}
        </>
    )
}

const FavoriteButton = ({ content, isSaving, onToggleFavorite, isMinimumSize }: ActionProps) => {
    return (
        <>
            {!content ||
                (!content.isFavorite && (
                    <Button
                        colorScheme="yellow"
                        variant="outline"
                        leftIcon={<FontAwesomeIcon icon={faStar} />}
                        onClick={() => { onToggleFavorite(true); }}
                        isLoading={isSaving}
                        title="Marcar como favorito"
                        iconSpacing={ isMinimumSize ? 1 : 0}
                    >
                        {isMinimumSize ? "Marcar como favorito" : ""}
                    </Button>
                ))}
            {content?.isFavorite && (
                <Button
                    colorScheme="yellow"
                    variant="solid"
                    leftIcon={<FontAwesomeIcon icon={faStarHalfStroke} />}
                    onClick={() => { onToggleFavorite(false); }}
                    isLoading={isSaving}
                    iconSpacing={isMinimumSize ? 1 : 0}
                    title="Desmarcar como favorito"
                >
                    {isMinimumSize ? "Desmarcar como favorito" : ""}
                </Button>
            )}
        </>
    );
};

const FavoriteItem = ({ content, isSaving, onToggleFavorite }: ActionProps) => {
    return <>
        {content?.isFavorite &&
            <MenuItem onClick={() => { onToggleFavorite(false); }} icon={isSaving ? <Spinner /> : <FontAwesomeIcon icon={faStar} />}>
                Marcar como favorito
            </MenuItem>
        }
        {!content?.isFavorite && 
            <MenuItem onClick={() => { onToggleFavorite(true); }} icon={isSaving ? <Spinner /> : <FontAwesomeIcon icon={faStarHalfStroke} />}>
            Desmarcar como favorito
            </MenuItem>
        }
    </>;
}

export default FavoriteAction;
